
import firebase from 'firebase/app'
import 'firebase/functions'
import sh from '@/helpers/StringHelpers'
import StringHelpers from './StringHelpers'

export default class CloudHelpers {
    static validateEmail(email) {  
        return new Promise( (resolve, reject) => {
            if(!sh.isEmail(email)) {
                resolve('Invalid email format')
                return
            }

            console.log('Validating')

            var validateEmail = firebase.functions().httpsCallable('validateEmail')
            validateEmail(email).then(function(response) {
                if(response.data.result == 'valid') {
                    console.log('Valid')
                    resolve('')
                } else {
                    console.log(response.data.message)
                    resolve(response.data.message)
                }
            }).catch(err => {
                console.log(err)
                resolve(err)
            })
        }) 
    }

    static getGender(firstName) {  
        //Uses free api at https://genderize.io/ and associated library
        return new Promise( (resolve, reject) => {
            if(!firstName) {
                resolve('')
                return
            }

            var getGender = firebase.functions().httpsCallable('getGender')
            getGender(firstName).then(function(response) {
                resolve(StringHelpers.capitalizeFirstLetter(response.data))
            }).catch(function(err){
                resolve('')
            })
        }) 
    }
}


// WEBPACK FOOTER //
// ./src/helpers/CloudHelpers.js